import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/Home.vue';
import Certification from './views/Certification.vue';
import Produits from './views/Non utilise/Produits.vue';
import Services from './views/Services.vue';
import Marques from './views/Non utilise/Marques.vue';
import References from './views/References.vue';
import Contact from './views/Contact.vue';
import Panier from './views/Non utilise/Panier.vue';
import Reactifs from './views/Non utilise/Reactifs.vue';
import VitaminesMineraux from './views/Non utilise/Vitamines-mineraux.vue';
import Glucotest from './views/Non utilise/Glucotest.vue';
import QualiteCertifications from './views/qualite-certifications.vue';
import Maintenance from "./views/Maintenance.vue";


const MAINTENANCE_MODE = false;

const routes = [
  { path: "/maintenance", name: "Maintenance", component: Maintenance },
  { path: '/', component: Home },
  { path: '/certification', component: Certification },
  { path: '/produits', component: Produits },
  { path: '/services', component: Services },
  { path: '/marques', component: Marques },
  { path: '/references', component: References },
  { path: '/contact', component: Contact },
  { path: '/panier', component: Panier },
  { path: '/reactifs', component: Reactifs },
  { path: '/vitamines-mineraux', component: VitaminesMineraux },
  { path: '/glucotest', component: Glucotest },
  { path : '/qualite-certifications', component:QualiteCertifications },
];


const router = createRouter({
  history: createWebHistory(),
  routes,
    // Fonction pour gérer le comportement du défilement
 /* scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Garde la position du scroll si on revient à une page précédente
    } else {
      return { top: 0 }; // Scrolle tout en haut
    }
  },*/

    // Fonction pour gérer le comportement du défilement
  scrollBehavior() {
    return { top: 0 }; // Scrolle toujours en haut
  },
});

router.beforeEach((to, from, next) => {
  if (MAINTENANCE_MODE && to.name !== "Maintenance") {
    next({ name: "Maintenance" });
  } else {
    next();
  }
});

export default router;
